import { ForwardRefExoticComponent, RefAttributes, SVGAttributes } from 'react'

interface Props {
  title: string
  Icon: ForwardRefExoticComponent<
    SVGAttributes<SVGSVGElement> & RefAttributes<SVGSVGElement>
  >
  values: string[]
  listStyle?: string
}

const ValueSummaryItem = ({ title, Icon, values, listStyle }: Props) => (
  <article className="md:flex-1 md:py-4">
    <header className="flex flex-wrap items-center md:mb-1 mb-6">
      <Icon
        className="fill-neutral-90 md:h-14 h-12 md:w-14 w-12 md:mr-4 mr-3"
        aria-hidden="true"
      />
      <h3 className="text-neutral-90 md:text-2xl md:leading-[29px] text-lg leading-[21px] font-natosans-medium flex-1">
        {title}
      </h3>
    </header>
    <ul className="space-y-6 text-neutral-80 md:text-xl text-base leading-[1.875] md:ml-[72px] ml-5 list-disc font-natosans-light">
      {values.map((value) => (
        <li key={value}>{value}</li>
      ))}
    </ul>
  </article>
)

export default ValueSummaryItem
